import YatungFadeMenu from '@Src/_basic/components/YatungFadeMenu';
import { useAuth } from '@Src/redux/auth/authActions';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function ProdoctionManagementFadeMenu() {
  const { t: i18T } = useTranslation();
  const { userApiPermission } = useAuth();
  const [newRouteSideMenu, setNewRouteSideMenu] = React.useState<Array<any>>([]);

  const routeSideMenu = [
    {
      title: i18T('APPLICATIONSMANAGEMENT.TEST_MANAGE.TITLE'),
      toUrl: '/qualityManagement/testManage',
      code: 'WD038',
    },
    {
      title: i18T('APPLICATIONSMANAGEMENT.SAMPLE_COURSE.TITLE'),
      toUrl: '/qualityManagement/SampleCourse',
      code: 'WD063',
    },
  ];

  useEffect(() => {
    const routeSideMenuTemp: Array<any> = [];
    routeSideMenu.forEach((item) => {
      if (userApiPermission.includes(item.code as string)) {
        routeSideMenuTemp.push(item);
      }
    });
    setNewRouteSideMenu(routeSideMenuTemp);
  }, [userApiPermission]);
  return (
    <>
      {newRouteSideMenu.length > 0 && (
        <YatungFadeMenu
          text={i18T('APPLICATIONSMANAGEMENT.SIDE_MENU.PRODUCTION_MANAGEMENT')}
          option={newRouteSideMenu}
        />
      )}
    </>
  );
}
